import { TCreateTagFields } from 'shared/types'
import { api } from '..'

export const editTag = (tagId: string) => (data: TCreateTagFields) =>
  api.put(`/v1/tags/${tagId}/information`, data)
